<template>
  <b-container id="requestForm" class="mb-5">
    <b-row align-h="center">
      <b-col cols="auto">
        <b-form @submit.prevent="handleSubmit" v-if="isFormVisible">
          <b-form-group :label="$t('E7')" label-align="right" label-cols="6">
            <b-form-input
              type="text"
              v-model="request.requesterName"
              required
            />
          </b-form-group>
          <b-form-group :label="$t('E8')" label-align="right" label-cols="6">
            <b-form-select
              type="text"
              v-model="request.cityId"
              @change="onCityChange"
              required
            >
              <option
                v-for="city in cityOptions"
                v-bind:key="city.citId"
                v-bind:value="city.citId"
              >
                {{ city.citName }}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group :label="$t('E9')" label-align="right" label-cols="6">
            <b-form-select
              type="text"
              v-model="request.districtId"
              @change="onDistrictChange"
              required
            >
              <option
                v-for="district in districtOptions"
                v-bind:key="district.disId"
                v-bind:value="district.disId"
              >
                {{ district.disName }}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group :label="$t('E15')" label-align="right" label-cols="6">
            <b-form-input
              type="text"
              v-model="request.requesterStreet"
              required
            />
          </b-form-group>
          <b-form-group :label="$t('E11')" label-align="right" label-cols="6">
            <b-form-input
              type="date"
              v-model="request.childbirthDate"
              required
            />
          </b-form-group>
          <b-form-group :label="$t('E12')" label-align="right" label-cols="6">
            <b-form-input type="text" v-model="request.phoneNumber" required />
          </b-form-group>
          <b-form-group :label="$t('E13')" label-align="right" label-cols="6">
            <b-form-input type="email" v-model="request.email" required />
          </b-form-group>
          <b-form-group :label="$t('E14')" label-align="right" label-cols="6">
            <b-form-select type="text" v-model="request.wishUserId">
              <option
                v-for="deliveryNurse in wishDeliveryNursesOptions"
                v-bind:key="deliveryNurse.usrId"
                v-bind:value="deliveryNurse.usrId"
              >
                {{ deliveryNurse.usrFirstName }} {{ deliveryNurse.usrLastName }}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group>
            Mehr Informationen zu unseren Hebammen finden Sie im Netz oder unter
            diesem
            <a
              href="https://familien.landratsamt-roth.de/einrichtungen/hebammen-2cf3d846-c097-4747-bc4d-058f6bd8479d"
              target="_blank"
            >
              Link
            </a>
          </b-form-group>
          <b-form-group :label="$t('T5')">
            <service-picker
              align="left"
              v-model="request.services"
              :all-services="servicesOptions"
            />
          </b-form-group>
          <b-form-group>
            <b-form-checkbox
              align="left"
              value="privacyAccepted"
              required
              v-model="privacyChecked"
            >
              <a href="#" @click.prevent="showPrivacyModal()">{{ $t("T2") }}</a>
            </b-form-checkbox>
          </b-form-group>
          <b-form-group>
            <b-form-checkbox
              align="left"
              value="termsOfServiceAccepted"
              required
              v-model="termsOfServiceChecked"
            >
              <a href="#" @click.prevent="showTermsOfServiceModal()">{{
                $t("T1")
              }}</a>
            </b-form-checkbox>
          </b-form-group>
          <b-alert
            dismissible
            @dismissed="success = false"
            variant="success"
            :show="success"
          >
            {{ $t("T4") }}
          </b-alert>
          <b-button
            block
            :disabled="!privacyChecked || !termsOfServiceChecked"
            type="submit"
            variant="primary"
          >
            <font-awesome-icon
              :icon="['far', 'paper-plane']"
            ></font-awesome-icon>
          </b-button>
        </b-form>
      </b-col>
    </b-row>
    <privacy-info-modal ref="modal-privacy" />
    <terms-of-service-modal ref="modal-terms-of-service" />
  </b-container>
</template>

<script>
import ServicePicker from "./ServicePicker";
import PrivacyInfoModal from "./modals/PrivacyInfoModal";
import TermsOfServiceModal from "./modals/TermsOfServiceModal";
import { modalBaseMixin } from "../mixins/modalBase";
export default {
  components: { TermsOfServiceModal, PrivacyInfoModal, ServicePicker },
  data: function() {
    return {
      errors: [],
      success: false,
      isFormVisible: true,
      privacyChecked: false,
      termsOfServiceChecked: false,
      wishDeliveryNursesOptions: [],
      cityOptions: [],
      districtOptions: [],
      servicesOptions: [],
      request: {
        cityId: "",
        districtId: "",
        requesterName: "",
        requesterStreet: "",
        phoneNumber: "",
        email: "",
        childbirthDate: "",
        wishUserId: "",
        services: []
      }
    };
  },
  mixins: [modalBaseMixin],
  methods: {
    onDistrictChange(event) {
      this.$http
        .get("user/district/" + event)
        .then(response => {
          this.wishDeliveryNursesOptions = response.data.data;
        })
        .catch(e => {
          this.errors.push(e);
        });
    },
    onCityChange(event) {
      this.$http
        .get("district/" + event)
        .then(response => {
          this.districtOptions = response.data.data;
        })
        .catch(e => {
          this.errors.push(e);
        });
    },
    handleSubmit() {
      this.success = false;
      const data = new FormData();
      data.append("cityId", this.request.cityId);
      data.append("districtId", this.request.districtId);
      data.append("requesterName", this.request.requesterName);
      data.append("requesterStreet", this.request.requesterStreet);
      data.append("phoneNumber", this.request.phoneNumber);
      data.append("email", this.request.email);
      data.append("childbirthDate", this.request.childbirthDate);
      data.append("wishUserId", this.request.wishUserId);
      data.append("languageCode", this.$i18n.locale);
      for (let i = 0; i < this.request.services.length; i++) {
        data.append("services[]", this.request.services[i]);
      }
      this.$http
        .post("/request/create", data)
        .then(() => {
          this.resetForm();
          this.success = true;
        })
        .catch(e => {
          this.errors.push(e);
        });
    },
    resetForm() {
      this.request.cityId = "";
      this.request.districtId = "";
      this.request.requesterName = "";
      this.request.requesterStreet = "";
      this.request.phoneNumber = "";
      this.request.email = "";
      this.request.childbirthDate = "";
      this.request.wishUserId = "";
      this.request.services = [];
      this.privacyChecked = false;
      this.termsOfServiceChecked = false;
      this.isFormVisible = false;
      this.$nextTick(() => {
        this.isFormVisible = true;
      });
    },
    showPrivacyModal() {
      this.$refs["modal-privacy"].show();
    },
    showTermsOfServiceModal() {
      this.$refs["modal-terms-of-service"].show();
    }
  },
  created() {
    this.$http
      .get("request/options")
      .then(response => {
        this.cityOptions = response.data.data.cities;
        this.servicesOptions = response.data.data.services;
      })
      .catch(e => {
        this.errors.push(e);
      });
  }
};
</script>
